import {parseLinkTemplate, renderParameterizedString} from '@specials/utils-react';

import {FindAppButton} from '@/ui/components/FindAppButton/FindAppButton';
import {FindAppImage} from '@/ui/components/FindAppImage/FindAppImage';
import {ButtonLink, ButtonLinkMods} from '@/ui/kit/ButtonLink/ButtonLink';
import {CrystalIcon} from '@/ui/kit/icons/CrystalIcon';

import s from './ParameterizedText.module.css';

export interface Props {
  template: string;
}

export function ParameterizedText({template}: Props): JSX.Element {
  const ul = (text: string): JSX.Element => {
    return (
      <ul className={s.unorderedList}>
        <ParameterizedText template={text} />
      </ul>
    );
  };

  const ol = (text: string): JSX.Element => {
    return (
      <ol className={s.orderedList}>
        <ParameterizedText template={text} />
      </ol>
    );
  };

  const li = (text: string): JSX.Element => {
    return (
      <li className={s.listItem}>
        <span className={s.listText}>
          <ParameterizedText template={text} />
        </span>
      </li>
    );
  };

  const link = (linkTemplate: string): JSX.Element => {
    const {text, href} = parseLinkTemplate(linkTemplate);

    return (
      <ButtonLink mod={ButtonLinkMods.LinkBordered} href={href} className={s.link}>
        {text}
      </ButtonLink>
    );
  };

  const bold = (text: string): JSX.Element => <b>{text}</b>;

  const email = (text: string): JSX.Element => <ButtonLink href={`mailto:${text}`}>{bold(text)}</ButtonLink>;

  const br = (): JSX.Element => <br />;

  const u = (text: string): JSX.Element => <u>{text}</u>;

  const yellow = (text: string): JSX.Element => <span className={s.yellowText}>{text}</span>;

  return (
    <>
      {renderParameterizedString(template, {
        ul,
        ol,
        li,
        bold,
        email,
        link,
        br,
        u,
        yellow,
        FindAppImage: () => <FindAppImage className={s.image} />,
        FindAppButton: () => (
          <div className={s.button}>
            <FindAppButton />
          </div>
        ),
        CrystalIcon: () => <CrystalIcon className={s.crystalIcon} />,
      })}
    </>
  );
}
